'use client';

import { ComponentPropsWithoutRef } from 'react';
import { useIsInertBecauseOfMenu } from '../pageHeader/mainMenu/MainMenu.client';
import { classes } from '@/uiPrimitives/base/classes.helpers';

export const Main = ({
	className,
	...props
}: ComponentPropsWithoutRef<'main'>) => {
	const inert = useIsInertBecauseOfMenu();

	return <main {...props} inert={inert} className={classes(className)} />;
};
